export enum QuizButtonStatusEnum {
    Generate = 'generate',
    Go = 'go',
    Disable = 'disable',
    ViewProtocol = 'viewProtocol',
    Loading = 'Loading'
}